export enum SerialNumberTypeEnum {
  Individual = 'Individual',
  Batch = 'Batch',
}
